<template src="./companychecktemplatechecks.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {},
    filters: {},
    data() {
      return {
        FleetSubscription: {},
        CountAssetTemplateChecks: 0,
        ShowLoader: false,
        Editmode: false,
        Submitted: false,
        TemplateData: {},
        CompanyCheckTemplateChecks: [],
        TemplateID: 0,
        showCopyTemplatesPopup:false
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Settings";
      this.TemplateID = this.$route.params.TemplateId;
      this.GetCompanySubscription();
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
    },
    methods: {
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isAssets = FleetSubscriptionModules.Assets;
        if (isAssets) {
          this.GetCompanyCheckTemplateChecks();
        } else {
          this.$router.push("/settings");
        }
      },
      EnableEditMode() {
        this.Editmode = true;
      },
      DisableEditMode() {
        this.Editmode = false;
      },
      GetCompanyCheckTemplateChecks() {
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleCheckTemplate.TemplateChecks.List, {
          token: localStorage.getItem("token"),
          template_id: this.TemplateID,
        }).then((Response) => {
          this.ShowLoader = false;
          this.TemplateData = Response.data.TemplateData;
          this.CompanyCheckTemplateChecks = Response.data.TemplateChecks;
          this.CompanyCheckTemplateChecks.forEach((element, index) => {
          if (this.CompanyCheckTemplateChecks[index]["description"]) {
            this.CompanyCheckTemplateChecks[index]["description"] = this.CompanyCheckTemplateChecks[
              index
            ]["description"].replaceAll(/(?:\\[rn])+/g, "");
          }

          if (element.required == 1) {
            this.CompanyCheckTemplateChecks[index]["required"] = true;
          } else {
            this.CompanyCheckTemplateChecks[index]["required"] = false;
          }
          
          if (element.photo_required == 1) {
            this.CompanyCheckTemplateChecks[index]["photo_required"] = true;
          } else {
            this.CompanyCheckTemplateChecks[index]["photo_required"] = false;
          }
          this.CountAssetChecks();
        });
        });
      },
      CountAssetChecks() {
        this.CountAssetTemplateChecks = this.CompanyCheckTemplateChecks.length;
      },   
      SaveTemplateCheck() {
        var error = false;
        this.CompanyCheckTemplateChecks.forEach((element) => {
          if (element.id == 0) {
            if (element.name == "") {
              error = true;
              this.$swal("Please Enter Check Name", "", "error");
              return true;
            }
          }
        });
        if (!error) {
          this.Submitted = true;
          this.CompanyCheckTemplateChecks.template_id = this.TemplateID;
          Axios.post(Endpoints.VehicleCheckTemplate.TemplateChecks.Create, {
            token: localStorage.getItem("token"),
            CompanyCheckTemplateChecks: this.CompanyCheckTemplateChecks,
            template_id: this.TemplateID,
          }).then((Response) => {
            this.Submitted = false;
            this.$swal(
              "Template Check Saved Successfully",
              "",
              "success"
            ).then(() => {
              this.GetCompanyCheckTemplateChecks();
            });
          });
        }
      },
      DeleteCheck (checkid) {
        this.$swal({
          title: "Are you sure You want to delete this Check Record?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.VehicleCheckTemplate.TemplateChecks.Delete, {
              token: localStorage.getItem("token"),
              id: checkid,
            }).then((Response) => {
              this.CompanyCheckTemplateChecks.forEach((value, index) => {
                if (value.id == checkid) {
                  this.CompanyCheckTemplateChecks.splice(index, 1);
                }
              });
              this.$swal(
                "Template Check Record Deleted Successfully",
                "",
                "success"
              ).then(() => {
                this.GetCompanyCheckTemplateChecks();
              });
            });
          }
        });
      },
      AddCustomTemplateCheck() {
        /*if (
          this.FleetSubscription &&
          this.FleetSubscription.allowed_total_asset_checks >
            this.CountAssetTemplateChecks
        ) { */
        this.Editmode = true;
        var obj = {
          custom: 1,
          id: 0,
          name: "",
          description: "",
          template_id: this.TemplateID,
          position: this.CompanyCheckTemplateChecks.length + 1,
          required: 0,
          photo_required: 0,
          status: 1,
        };
        this.CompanyCheckTemplateChecks.push(obj);
        this.CountAssetChecks();
      /*}else {
          this.$swal(
            "You have reached your subscription's maximum allowed asset checks. Please contact us to add more checks",
            "",
            "error"
          );
        }*/
      },
    },
  };
</script>

<style type="text/css"></style>
